import { faChargingStation } from '@fortawesome/pro-duotone-svg-icons';

// This icon will be used in AssistantHeader
export const headerIcon = faChargingStation;

// Export icons that are needed in this assistant only
// ! You should import the icons directly where needed, if possible !
export default {};
